import React from 'react';
import { Icon } from '../../../../../common/components';
import { Button } from '../../../../../common/components/Button/Button';

class ActiveProducts extends React.Component {
  render() {
    return (
      <div className="mt-15">
        <h5>Active Products</h5>
        <div className="active-Product-row">
          <div className="flex-left">
            <Icon name="plane" /> Leisure Travel
          </div>
          <div className="row-actions">
            <Button size={'xs'} className="btn-blue">
              Get a quote
            </Button>
            <Button size={'xs'} className="ml-15 btn-blue">
              View / Edit
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default ActiveProducts;
